// Disable FontAwesome Kit's auto SVG replacement so it doesn't interfere with
// font-based FA icons used on the host ASP.NET pages.
// Case 1: Angular loads before the Kit script — Kit will read this config at init time.
(window as Window & { FontAwesomeConfig?: { autoReplaceSvg: boolean } }).FontAwesomeConfig = { autoReplaceSvg: false };

// Set webpack public path to the folder where this script was loaded from,
// so lazy-loaded chunks resolve relative to main.js (e.g. the CDN URL) instead
// of the page URL. Must run before any other imports.
declare let __webpack_public_path__: string;
{
  const currentScript = document.currentScript as HTMLScriptElement | null;
  const scriptSrc =
    currentScript?.src ??
    (() => {
      const scripts = document.getElementsByTagName('script');
      for (let i = scripts.length - 1; i >= 0; i--) {
        const src = scripts[i].src;
        if (src && /\/main(\.[a-f0-9]+)?\.js(\?.*)?$/i.test(src)) {
          return src;
        }
      }
      return '';
    })();
  if (scriptSrc) {
    __webpack_public_path__ = scriptSrc.substring(0, scriptSrc.lastIndexOf('/') + 1);
  }
}

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Case 2: Kit script loaded before Angular — stop the MutationObserver now.
    (window as Window & { FontAwesome?: { dom?: { unwatch?: () => void } } }).FontAwesome?.dom?.unwatch?.();
  })
  .catch(err => console.error(err));
